function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.4691 40.7984C46.5296 38.9948 44.6401 33.4061 43.6454 31.6324C43.045 32.2584 32.5183 36.6456 22.3398 39.2459C12.1631 41.847 1.70312 42.8789 1.70312 42.8789C1.70312 42.8789 2.2604 44.456 2.98333 45.7569C3.72305 47.0877 5.76737 50.0812 5.91672 50.2888C6.05215 50.4758 15.4396 49.8853 25.0017 47.6729C36.0628 45.1142 47.502 40.8611 47.4691 40.7984Z",
  fill: "#8E58ED"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.1756 10.5402L43.7007 25.1042C41.8254 26.1551 40.9304 28.3416 41.5489 30.3651L45.584 43.5656C46.2069 45.6032 48.1955 46.9172 50.3502 46.7188L85.5789 40.4644L76.1756 10.5402Z",
  fill: "#8E58ED"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.752 31.6866L86.871 41.4353C82.9213 42.643 78.7387 40.408 77.5263 36.4418L72.3646 19.5558C71.1527 15.5911 73.3702 11.3974 77.3199 10.1896L109.201 0.440925C113.149 -0.766382 117.332 1.47011 118.544 5.43483L123.706 22.3209C124.918 26.2871 122.701 30.4793 118.752 31.6866Z",
  fill: "#A883EA"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.8001 33.7602L76.1958 18.6978C75.3573 15.9545 76.9419 13.0391 79.734 12.1853L109.561 3.06485C112.354 2.21062 115.296 3.74181 116.135 6.48505L120.739 21.5475C121.578 24.2908 119.995 27.2071 117.202 28.0614L87.3749 37.1819C84.5828 38.0356 81.6387 36.5035 80.8001 33.7602Z",
  fill: "#3E1641"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M91.9591 8.44648L86.0628 37.5825L89.9548 36.3924L95.8953 7.24288L91.9591 8.44648Z",
  fill: "white"
});

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 125,
    height: 64,
    viewBox: "0 0 125 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.5532a2f0.svg";
export { ForwardRef as ReactComponent };